import {
defineCustomElement,
MediaTimeSliderElement,
MediaSliderValueElement
} from "vidstack/elements";

defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSliderValueElement);